import { Link } from "react-router-dom";
import { SITE } from "../config";

export const Breadcrumbs = ({ items }) => {
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map((it, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: it.label,
            item: SITE.domain + (it.to || "/"),
        })),
    };
    return (
        <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="container-x pt-6">
            <ol className="flex flex-wrap items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[#8a877a]">
                {items.map((it, i) => (
                    <li key={it.label} className="flex items-center gap-2">
                        {i > 0 && <span aria-hidden="true">/</span>}
                        {it.to && i < items.length - 1 ? (
                            <Link to={it.to} className="hover:text-[#6e6234]">
                                {it.label}
                            </Link>
                        ) : (
                            <span aria-current="page" className="text-[#23231f]">
                                {it.label}
                            </span>
                        )}
                    </li>
                ))}
            </ol>
            <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        </nav>
    );
};
